/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  registerDecorator,
  ValidationArguments,
  ValidationOptions,
  ValidatorConstraint,
  ValidatorConstraintInterface,
} from 'class-validator';
import { isEqual } from 'lodash';

@ValidatorConstraint({ name: 'IsDeepEqual' })
export class IsNotDeepEqualConstraint implements ValidatorConstraintInterface {
  validate(value: any, args: ValidationArguments) {
    const [obj] = args.constraints;
    return !isEqual(value, obj);
  }

  defaultMessage() {
    return `Field is required`;
  }
}

export function IsNotDeepEqual(
  obj: any,
  validationOptions?: ValidationOptions,
) {
  return (object: any, propertyName: string) => {
    registerDecorator({
      target: object.constructor,
      propertyName,
      options: validationOptions,
      constraints: [obj],
      validator: IsNotDeepEqualConstraint,
    });
  };
}
